import { ReactNode, useLayoutEffect } from 'react';

import './OpWithoutSidebar.scss';

/**
 * @description This component is used to hide the sidebar for children.
 *
 * While it'd be preferred to make this a bit more declarative on the routes
 * themselves, this is not possible in a straightforward manner without
 * introducing "clever" code. Hiding with CSS and cleaning things up at the
 * time of unmount feels like a reasonable compromise.
 */
export const OpWithoutSidebar = ({ children }: { children: ReactNode }) => {
  useLayoutEffect(() => {
    const nav = document.querySelector('.op-app-nav');
    if (nav) {
      nav.classList.add('op-app-nav--hidden');
    }

    return () => {
      if (nav) {
        nav.classList.remove('op-app-nav--hidden');
      }
    };
  }, []);

  return children;
};
